import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { IDocument } from '../generic';

export interface IPricelist extends IDocument {
  price: number;
  description: string;
  category: ICategory;
  categoryId: string;
  photoURL?: string;
  sortOrder?: number;
}

export interface ICategory extends IDocument {
  name: string;
  sortOrder?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PricelistService {

  constructor(private afStore: AngularFirestore) { }

  deletePricelist(eventId: string, key: string) {
      return this.afStore.doc<IPricelist>(`/event/${eventId}/pricelist/${key}`).delete();
  }

  deleteCategory(eventId: string, key: string) {
    return this.afStore.doc<ICategory>(`/event/${eventId}/category/${key}`).delete();
}

  getPricelist(eventId: string) {
    return this.afStore.collection<IPricelist>(`/event/${eventId}/pricelist`,  ref => ref.orderBy('sortOrder', 'asc')).valueChanges({ idField: 'key' });
  }

  getCategory(eventId: string) {
    return this.afStore.collection<ICategory>(`/event/${eventId}/category`, ref => ref.orderBy('sortOrder', 'asc')).valueChanges({ idField: 'key' });
  }

  updateCategory(eventId: string, key: string, categoryItem: ICategory) {
    if(!key) {
      return this.afStore.collection<ICategory>(`/event/${eventId}/category`).add(categoryItem);
    }

    return this.afStore.doc<ICategory>(`/event/${eventId}/category/${key}`)
    .update(categoryItem)
  }

  updatePricelistItem(eventId: string, key: string, pricelistItem: IPricelist) {
    if(!key) {
      return this.afStore.collection<IPricelist>(`/event/${eventId}/pricelist`).add(pricelistItem);
    }

    return this.afStore.doc<IPricelist>(`/event/${eventId}/pricelist/${key}`)
    .update(pricelistItem)
  }

  updateAllPricelistItems() {
    return this.afStore.collectionGroup<IPricelist>(`pricelist`).get().forEach((pricelistitem) => {
      pricelistitem.forEach((item) => {
        console.log(item.data())
        item.ref.update({
          categoryId: item.data().category.key
        })
      })
    })
  }

  updateAllCategories() {
    return this.afStore.collectionGroup<IPricelist>(`category`).get().forEach((category) => {
      category.forEach((item) => {
      })
    })
  }
}
